import { render } from "./CreationTabs.vue?vue&type=template&id=540209bc&scoped=true"
import script from "./CreationTabs.vue?vue&type=script&lang=js"
export * from "./CreationTabs.vue?vue&type=script&lang=js"

import "./CreationTabs.vue?vue&type=style&index=0&id=540209bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540209bc"]])

export default __exports__